// extracted by css-extract-rspack-plugin
export default {"container":"src-domain-components-logical-device-battery-information-logicalDeviceBatteryInformation-module__container-LsT2mV","rightContainer":"src-domain-components-logical-device-battery-information-logicalDeviceBatteryInformation-module__rightContainer-A44d9T","leftContainer":"src-domain-components-logical-device-battery-information-logicalDeviceBatteryInformation-module__leftContainer-eQjFHU"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-domain-components-logical-device-battery-information-logicalDeviceBatteryInformation-module__container-LsT2mV\",\"rightContainer\":\"src-domain-components-logical-device-battery-information-logicalDeviceBatteryInformation-module__rightContainer-A44d9T\",\"leftContainer\":\"src-domain-components-logical-device-battery-information-logicalDeviceBatteryInformation-module__leftContainer-eQjFHU\"}";
        // 1793705033071
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  